// src/componentes/Escala11/Competicao/AdicionarCompeticao/index.tsx

import React, { useState } from "react"; // <--- Importação de useState
import { Button } from "@mui/material";
import Modal from "./Modal";
import AdicionarCompeticaoForm from "./AdicionarCompeticaoForm";

interface AdicionarCompeticaoProps {
  token: string;
  // O callback para notificar o componente pai
  onCompetitionCreated: () => void;
}

const AdicionarCompeticao: React.FC<AdicionarCompeticaoProps> = ({
  token,
  onCompetitionCreated,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleCompetitionCreated = () => {
    console.log(
      "Competição criada com sucesso! Chamando callback de atualização."
    );
    // 1. Notificar o pai para atualizar a lista
    onCompetitionCreated();
    // 2. Fechar o modal
    handleCloseModal();
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpenModal}
        sx={{
          minWidth: 200,
          backgroundColor: "#008870",
          "&:hover": {
            backgroundColor: "#005848ff",
          },
        }}
      >
        + Adicionar Nova Competição
      </Button>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title="Criar Nova Competição"
      >
        <AdicionarCompeticaoForm
          token={token}
          onSuccess={handleCompetitionCreated} // Passa a função que notifica o pai
          onClose={handleCloseModal}
        />
      </Modal>
    </>
  );
};

export default AdicionarCompeticao;
